// src/components/shared/modals/StaleSuggestionsModal.tsx
// Modal shown once when the optimizer transitions from 'complete' to 'stale',
// letting the user choose how to handle outdated suggestions.
import { RefreshCw, Trash2, Clock } from 'lucide-react';
import BaseModal from './BaseModal';

export interface StaleSuggestionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRecalculate: () => void;
  onClearSuggestions: () => void;
  onKeep: () => void;
  isGenerating?: boolean;
}

const StaleSuggestionsModal = ({
  isOpen,
  onClose,
  onRecalculate,
  onClearSuggestions,
  onKeep,
  isGenerating = false,
}: StaleSuggestionsModalProps) => {
  if (!isOpen) return null;

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title="Suggestions may be outdated"
      maxWidth="max-w-sm"
    >
      <div className="px-6 py-4">
        <p className="text-sm text-gray-600">
          Your plan has changed since suggestions were generated. They may no longer
          reflect the best options for your schedule.
        </p>
      </div>

      <div className="px-6 pb-5 flex flex-col gap-2">
        <button
          onClick={onRecalculate}
          disabled={isGenerating}
          className="w-full flex items-center gap-2.5 px-4 py-2.5 text-sm font-medium text-white bg-purple-600 rounded-md hover:bg-purple-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <RefreshCw className="h-4 w-4 flex-shrink-0" />
          Recalculate suggestions
        </button>

        <button
          onClick={onClearSuggestions}
          className="w-full flex items-center gap-2.5 px-4 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
        >
          <Trash2 className="h-4 w-4 flex-shrink-0" />
          Clear suggestions
        </button>

        <button
          onClick={onKeep}
          className="w-full flex items-center gap-2.5 px-4 py-2.5 text-sm font-medium text-gray-500 hover:text-gray-700 transition-colors"
        >
          <Clock className="h-4 w-4 flex-shrink-0" />
          Keep for now
        </button>
      </div>
    </BaseModal>
  );
};

export default StaleSuggestionsModal;
